module.exports = __webpack_public_path__ + "static/media/6.c8173e81.jpg";